import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isUserLoggedSelector } from '../Redux/LoggedUserSlice';

export default function PublicRoute({ component: Component, ...rest }) {
  const isUserLogged = useSelector(isUserLoggedSelector);

  // Si el estado aún no se determina (cargando), se asume que Routes.js maneja el estado de carga principal.
  if (isUserLogged === null) {
    return null; // O un componente de carga
  }

  return <Route {...rest} render={props => (isUserLogged ? <Redirect to="/dashboard" /> : <Component {...props} />)} />;
}
